export default __webpack_public_path__ + "static/media/it9.90a301ce.jpg";